module.exports = __webpack_public_path__ + "static/media/dashboard-icon.0fed798a.svg";